import script from "./ResourcePagination.vue?vue&type=script&lang=ts&setup=true"
export * from "./ResourcePagination.vue?vue&type=script&lang=ts&setup=true"

import "./ResourcePagination.vue?vue&type=style&index=0&id=2d2f7fc5&lang=css"

const __exports__ = script;

export default __exports__